export default "__VITE_ASSET__lzdCWl5u__"